export const topBrandsDresses = [
    {
        key: 'A.L.C.,AFRM,Agua Bendita,AIIFOS,ALALA,Alexander%20Wang,Alexis,Alice%20+%20Olivia,Alice%20McCall,ALLSAINTS,AMUR',
        label: 'Top Marcas'
    },
  ]
  